import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParams, msSize, SystemLocks, TypeLicence } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DatePipe } from '@angular/common';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LicenceSystemDTO } from 'src/app/core/models/system/licence/licence-system.dto';
import { LicencesSystemService } from 'src/app/core/services/utelize/system/licence/licences-system-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemLockDTO } from 'src/app/core/models/system/system-lock/system-lock.dto';
import { SystemLockService } from 'src/app/core/services/utelize/system/system-lock/system-lock-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesDataWeightService } from 'src/app/core/services/utelize/system/type/types-data-weight-service';
import { TypesLicenceService } from 'src/app/core/services/utelize/system/type/types-licence-service';
import { TypesRecurringService } from 'src/app/core/services/utelize/system/type/types-recurring-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';
import { WebComponentsService } from 'src/app/core/services/utelize/system/web/web-components-service';
import { WorldZonesService } from 'src/app/core/services/utelize/system/mapping/world-zones-service';

@Component({
  selector: 'app-licence-system-modal-form',
  templateUrl: './licence-system-modal-form.component.html',
  styleUrls: ['./licence-system-modal-form.component.scss']
})

export class LicenceSystemModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Output() thisFormSaved    : EventEmitter<number>=new EventEmitter<number>();
  @Output() thisFormCancelled: EventEmitter<void>  =new EventEmitter<void>  ();
  
  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('thisModalForm',      { static: false }) thisModalForm!     : TemplateRef<void>;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;

  get hasBundlePeriod  () { return this.isBundle || (this.isPoolBundle && this.poolBundlePeriodEnabled); }
  get showBilledPadlock() { return this.licenceEverBilled && this.canOverrideBilledEdit                ; }
                         
  get isLicencesAdminKeyHolder() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.LicencesAdminKey,           true); }
  get canOverrideBilledEdit   () { return this.billedEditOverrideEnabled &&
                                          this.componentAccessUserService.hasAccessGuid(AccessGuids.LicencesEditBilledOverride, true); }

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false)       }

  get billedEditOverrideEnabled    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesBilledEditOverrideEnabled,          false); }
  get lockEditAfterBilledBundle    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesLockEditAfterBilledBundle,          true ); }
  get lockEditAfterBilledPoolBundle() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesLockEditAfterBilledPoolBundle,      true ); }
  get lockEditAfterBilledUsage     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesLockEditAfterBilledUsage,           true ); }
  get poolBundlePeriodEnabled      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesPoolBundleEnablePeriodAndFrequency, false); }
  get systemLocksEnabled           () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksEnabled,                         true ); }
  get systemLocksShowDetails       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowDetails,                     true ); }
  get systemLocksShowWarningModal  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowWarningModal,                true ); }

  private bundlePeriodIdData!         : IdAndDescriptionDTO[];
  private dataWeightTypeIdData!       : IdAndDescriptionDTO[];
  private dataWeightTypeIdDataFiltered: IdAndDescriptionDTO[]=[];
  private featureGuidData!            : IdAndDescriptionDTO[];
  private initialStatus               : string="Please complete the following details";
  private licenceSystem               : LicenceSystemDTO | undefined;
  private licenceSystemId             : number | undefined;
  private licenceTypeIdData!          : IdAndDescriptionDTO[];
  private licenceTypeSelected         : IdAndDescriptionDTO | undefined;
  private paymentFrequencyIdData!     : IdAndDescriptionDTO[];
  private systemLockId                : number | undefined;
  private thisModalFormRef!           : NgbModalRef;
  private zoneIdData!                 : IdAndDescriptionDTO[];

  public alertColourOrderStatus : string=AlertClassColour.Grey;
  public alertColourProgress    : string=AlertClassColour.Grey;
  public billedOverrideUnlocked : boolean=false;
  public curUser                : SystemUserDTO;
  public fileLockHoverText      : string | undefined;
  public formIsLocked           : boolean=false;
  public formTitle              : string="Unset Form Title";
  public isAnnualBundlePeriod   : boolean=false;
  public isBundle               : boolean=false;
  public isFeature              : boolean=false;
  public isPlatform             : boolean=false;
  public isPoolBundle           : boolean=false;
  public isUsage                : boolean=false;
  public licenceEverBilled      : boolean=false;
  public newLicence             : boolean=false;
  public progressInformation    : string=this.initialStatus;
  public progressInformationShow: boolean=false;
  public showFeatureQuantity    : boolean=false;
  public submitButtonEnabled    : boolean=true;
  public thisForm!              : UntypedFormGroup;
  public thisFormSubmitted      : boolean=false;

  //#region for Validators
  
  public licenceNameMaxLength: number=100;
  
  //#endregion  

  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private datePipe                  : DatePipe,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private lastPassKillerService     : LastPassKillerService,
    private licencesSystemService     : LicencesSystemService,
    private modalService              : NgbModal,
    private systemLockService         : SystemLockService,
    private typesDataWeightService    : TypesDataWeightService,
    private typesLicenceService       : TypesLicenceService,
    private typesRecurringService     : TypesRecurringService,
    private webComponentsService      : WebComponentsService,
    private worldZonesService         : WorldZonesService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.alertColourProgress    =AlertClassColour.Grey;
      this.billedOverrideUnlocked =false;
      this.isAnnualBundlePeriod   =false;
      this.isBundle               =false;
      this.isFeature              =false;
      this.isPlatform             =false;
      this.isPoolBundle           =false;
      this.isUsage                =false;
      this.licenceEverBilled      =false;
      this.licenceSystem          =undefined;
      this.licenceTypeSelected    =undefined;
      this.progressInformation    =this.initialStatus;
      this.progressInformationShow=false;
      this.submitButtonEnabled    =true;
      this.thisFormSubmitted      =false;

      this.refreshAccessTypeData();
      this.refreshBundlePeriodData();
      this.refreshDataWeightTypeData();
      this.refreshFeatureData();
      this.refreshPaymentFrequencyData();
      this.refreshZoneData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(licenceSystemId: number): void {
    try {
      this.fileLockHoverText="Licence is being edited by another";
      this.formIsLocked     =false;
      this.systemLockId     =undefined;
      
      this.resetMainVariables();
      this.setUpForm();

      if (licenceSystemId != undefined && <number>licenceSystemId>0) {
          this.formTitle              ="Manage Licence";
          this.licenceSystemId        =licenceSystemId;
          this.newLicence             =false;
          this.progressInformationShow=false;
      
          this.processSystemLock();
          this.getLicenceSystem();
        } else {
          this.formTitle              ="Create Licence";
          this.licenceSystemId        =0;
          this.newLicence             =true;
          this.progressInformationShow=true;
          
          this.openModal();
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.thisModalFormRef=this.modalService.open(this.thisModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm

  get formOfThis() {
    return this.thisForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);

      this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      //CRN_20250808 - Validators also set in setOrClearValidators();

      if (formGroup==this.thisForm) {
        this.addFormControl(formGroup, "active",                 true     , []);
        this.addFormControl(formGroup, "addToNewCompany",        false    , []);
        this.addFormControl(formGroup, "adminLocked",            false    , []);
        this.addFormControl(formGroup, "allowanceMbOrGb",        undefined, []);
        this.addFormControl(formGroup, "allowMany",              false    , []);
        this.addFormControl(formGroup, "bundlePeriodTypeId",     undefined, []);
        this.addFormControl(formGroup, "dataWeightTypeId",       undefined, []);
        this.addFormControl(formGroup, "featureGuid",            undefined, []);
        this.addFormControl(formGroup, "licenceName",            undefined, [Validators.required, Validators.maxLength(this.licenceNameMaxLength)]);
        this.addFormControl(formGroup, "licenceTypeId",          undefined, [Validators.required]);
        this.addFormControl(formGroup, "numberOfEntities",       undefined, [this.quantityValidator()]);
        this.addFormControl(formGroup, "paymentFrequencyTypeId", undefined, []);
        this.addFormControl(formGroup, "platformAddOn",          false    , []);
        this.addFormControl(formGroup, "price",                  undefined, [Validators.required]);
        this.addFormControl(formGroup, "priceEur",               undefined, [Validators.required]);
        this.addFormControl(formGroup, "pricePerMb",             undefined, []);
        this.addFormControl(formGroup, "pricePerMbEur",          undefined, []);
        this.addFormControl(formGroup, "pricePerMbUsd",          undefined, []);
        this.addFormControl(formGroup, "priceUsd",               undefined, [Validators.required]);
        this.addFormControl(formGroup, "quantityEnabled",        false    , []);
        this.addFormControl(formGroup, "systemOwned",            false    , []);
        this.addFormControl(formGroup, "zoneId",                 undefined, []);
        this.addFormControl(formGroup, "zoneIDs",                []       , []);

        this.thisForm.get('licenceTypeId')?.valueChanges.subscribe(id => {
          this.onLicenceTypeChange(id);
        });

        this.thisForm.get('bundlePeriodTypeId')?.valueChanges.subscribe(id => {
          this.onBundlePeriodChange(<number>id);
        });

        if (!this.isLicencesAdminKeyHolder)
          this.thisForm.controls["adminLocked"].disable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | number[] | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup, clearFields: boolean, setLicenceType: boolean) {
    try {
      if (formGroup==this.thisForm) {
        this.thisForm.controls["active"]                .setValue(clearFields ? true      : this.licenceSystem?.active);
        this.thisForm.controls["addToNewCompany"]       .setValue(clearFields ? false     : this.licenceSystem?.addToNewCompany);
        this.thisForm.controls["adminLocked"]           .setValue(clearFields ? false     : this.licenceSystem?.adminLocked);

        if (!this.isLicencesAdminKeyHolder)
          this.thisForm.controls["adminLocked"].disable({ emitEvent: false });
        else
          this.thisForm.controls["adminLocked"].enable({ emitEvent: false });

        this.thisForm.controls["allowanceMbOrGb"]       .setValue(clearFields ? undefined : this.licenceSystem?.allowanceMbOrGb);
        this.thisForm.controls["allowMany"]             .setValue(clearFields ? false     : this.licenceSystem?.allowMany);
        this.thisForm.controls["bundlePeriodTypeId"]    .setValue(clearFields ? undefined : this.licenceSystem?.bundlePeriodTypeID);
        this.thisForm.controls["dataWeightTypeId"]      .setValue(clearFields ? undefined : this.licenceSystem?.dataWeightTypeID);
        this.thisForm.controls["featureGuid"]           .setValue(clearFields ? undefined : this.licenceSystem?.featureGUID);
        this.thisForm.controls["licenceName"]           .setValue(clearFields ? undefined : this.licenceSystem?.licenceName);
        this.thisForm.controls["numberOfEntities"]      .setValue(clearFields ? undefined : this.licenceSystem?.numberOfEntities);
        this.thisForm.controls["paymentFrequencyTypeId"].setValue(clearFields ? undefined : this.licenceSystem?.paymentFrequencyTypeID);
        this.thisForm.controls["platformAddOn"]         .setValue(clearFields ? false     : this.licenceSystem?.platformAddOn);
        this.thisForm.controls["price"]                 .setValue(clearFields ? undefined : this.licenceSystem?.price);
        this.thisForm.controls["priceEur"]              .setValue(clearFields ? undefined : this.licenceSystem?.priceEur);
        this.thisForm.controls["pricePerMb"]            .setValue(clearFields ? undefined : this.licenceSystem?.pricePerMb);
        this.thisForm.controls["pricePerMbEur"]         .setValue(clearFields ? undefined : this.licenceSystem?.pricePerMbEur);
        this.thisForm.controls["pricePerMbUsd"]         .setValue(clearFields ? undefined : this.licenceSystem?.pricePerMbUsd);
        this.thisForm.controls["priceUsd"]              .setValue(clearFields ? undefined : this.licenceSystem?.priceUsd);
        this.thisForm.controls["quantityEnabled"]       .setValue(clearFields ? false     : this.licenceSystem?.quantityEnabled);
        this.thisForm.controls["systemOwned"]           .setValue(clearFields ? false     : this.licenceSystem?.systemOwned);
        this.thisForm.controls["zoneId"]                .setValue(clearFields ? undefined : this.licenceSystem?.zoneID);
        this.thisForm.controls["zoneIDs"]               .setValue(clearFields ? []        : this.getInitialZoneIDs());

        if (setLicenceType)
          this.thisForm.controls["licenceTypeId"].setValue(clearFields ? undefined : this.licenceSystem?.licenceTypeID);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmitAttempt() {
    try {
      this.thisFormSubmitted=true;
      this.thisForm.get('numberOfEntities')!.updateValueAndValidity();
      if (this.thisForm.valid) {
          this.thisFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmit() {
    try {
      this.submitButtonEnabled=false;
      this.prepareToSaveLicenceSystem();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormCancel() {
    try {
      this.unlockEntity();
      this.thisFormCancelled.emit();
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="bundlePeriodTypeId") {
        return this.bundlePeriodIdData;

      } else if (fieldName=="dataWeightTypeId") {
        return this.isPoolBundle ? this.dataWeightTypeIdDataFiltered : this.dataWeightTypeIdData;

      } else if (fieldName=="featureGuid") {
        return this.featureGuidData;

      } else if (fieldName=="licenceTypeId") {
        return this.licenceTypeIdData;

      } else if (fieldName=="paymentFrequencyTypeId") {
        return this.paymentFrequencyIdData;

      } else if (fieldName=="zoneId") {
        return this.zoneIdData;
      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="bundlePeriodTypeId") {
              this.bundlePeriodIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="dataWeightTypeId") {
              this.dataWeightTypeIdData=(data as IdAndDescriptionDTO[]);
              this.refreshDataWeightTypeIdFilter();

            } else if (fieldName=="featureGuid") {
              this.featureGuidData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="licenceTypeId") {
              this.licenceTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="paymentFrequencyTypeId") {
              this.paymentFrequencyIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="zoneId") {
              this.zoneIdData=(data as IdAndDescriptionDTO[]);

            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshAccessTypeData() {
    try {
      this.getDropdownData(this.typesLicenceService.getIdAndDescription(), "licenceTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshBundlePeriodData() {
    try {
      this.getDropdownData(this.typesRecurringService.getIdAndDescriptionByFrequencyCodes(["A", "M"]), "bundlePeriodTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshDataWeightTypeIdFilter(): void {
    try {
      this.dataWeightTypeIdDataFiltered=
        this.dataWeightTypeIdData?.filter(x => x.description?.endsWith("(GB)") || x.description?.endsWith("(MB)")) ?? [];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshDataWeightTypeData() {
    try {
      this.getDropdownData(this.typesDataWeightService.getIdAndDescription(), "dataWeightTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshFeatureData() {
    try {
      this.getDropdownData(this.webComponentsService.getIdAndDescriptionForChargeable(), "featureGuid");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshPaymentFrequencyData() {
    try {
      this.getDropdownData(this.typesRecurringService.getIdAndDescriptionByFrequencyCodes(["A", "M"]), "paymentFrequencyTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshZoneData() {
    try {
      this.getDropdownData(this.worldZonesService.getIdAndDescription(), "zoneId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
      
  public getLicenceSystem() {
    try {
      this.licencesSystemService.getById(<number>this.licenceSystemId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.licenceSystem=data;
          
          this.populateFormFields(this.thisForm, false, true);
          this.thisForm.controls["licenceTypeId"].disable();
          this.evaluateAndLockBilledFields();
          this.openModal();
        },
        error: error => {
          this.thisFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private prepareToSaveLicenceSystem() {
    try {
      const licenceName: null | string | undefined=this.thisForm.controls["licenceName"].value;

      this.licenceSystem={
        active                : this.thisForm.controls["active"].value,
        addToNewCompany       : this.thisForm.controls["addToNewCompany"].value,
        adminLocked           : this.thisForm.controls["adminLocked"].getRawValue() ?? false,
        allowanceMbOrGb       : this.thisForm.controls["allowanceMbOrGb"].getRawValue(),
        allowMany             : this.thisForm.controls["allowMany"].value,
        billedEditOverride    : this.billedOverrideUnlocked,
        bundlePeriodTypeID    : this.hasBundlePeriod
                                ? this.thisForm.controls["bundlePeriodTypeId"].getRawValue()
                                : null,
        dataWeightTypeID      : this.isBundle
                                ? this.findDataWeightTypeIdByCode("GB")
                                : this.isPoolBundle
                                  ? this.thisForm.controls["dataWeightTypeId"].getRawValue()
                                  : null,
        enteredBy             : this.curUser.userId,
        featureGUID           : this.thisForm.controls["featureGuid"].value,
        id                    : this.licenceSystemId ?? -1,
        licenceName           : <string>licenceName,
        licenceTypeID         : this.thisForm.controls["licenceTypeId"].value,
        numberOfEntities      : this.thisForm.controls["numberOfEntities"].value,
        paymentFrequencyTypeID: this.hasBundlePeriod
                                ? this.thisForm.controls["paymentFrequencyTypeId"].getRawValue()
                                : null,
        platformAddOn         : this.thisForm.controls["platformAddOn"].value,
        price                 : this.isPoolBundle ? 0 : this.thisForm.controls["price"].getRawValue(),
        priceEur              : this.isPoolBundle ? 0 : this.thisForm.controls["priceEur"].getRawValue(),
        pricePerMb            : this.thisForm.controls["pricePerMb"].getRawValue(),
        pricePerMbEur         : this.thisForm.controls["pricePerMbEur"].getRawValue(),
        pricePerMbUsd         : this.thisForm.controls["pricePerMbUsd"].getRawValue(),
        priceUsd              : this.isPoolBundle ? 0 : this.thisForm.controls["priceUsd"].getRawValue(),
        quantityEnabled       : this.thisForm.controls["quantityEnabled"].value,
        systemOwned           : this.thisForm.controls["systemOwned"].value,
        zoneID                : (this.isBundle || this.isPoolBundle || this.isUsage) ? 0 : this.thisForm.controls["zoneId"].value,
        zoneIDs               : (this.isBundle || this.isPoolBundle || this.isUsage) ? <number[]>(this.thisForm.controls["zoneIDs"].getRawValue() ?? []) : []
      };
      
      this.saveLicenceSystem(<LicenceSystemDTO>this.licenceSystem)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.alertColourProgress=AlertClassColour.Green;

          if (this.newLicence) {
            this.licenceSystem!.id  =data["id"];
            this.licenceSystemId    =data["id"];
            this.progressInformation=`${licenceName} has been registered on the ${ApplicationNames.eSimPlatform}`;

          } else {
            this.progressInformation=`${licenceName} details have been updated on the ${ApplicationNames.eSimPlatform}`;
          }
          
          this.processComplete();
          this.thisFormSaved.emit(this.licenceSystemId);
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation=`Process cannot continue - ${error?.message}`;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public quantityValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;

        const featureGUID     = parent.get("featureGuid");
        const quantityEnabled = parent.get("quantityEnabled");
        var result = (featureGUID && featureGUID.value != "") && (quantityEnabled && quantityEnabled.value == true) && (value == null || (value != null && value == "")) ? { quantityRequired: true } : null;

        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }

  private evaluateAndLockBilledFields(): void {
    try {
      const hasBilled : boolean=this.licenceSystem?.hasEverBilled ?? false;
      const lockBundle: boolean=this.isBundle     && this.lockEditAfterBilledBundle     && hasBilled;
      const lockPool  : boolean=this.isPoolBundle && this.lockEditAfterBilledPoolBundle && hasBilled;
      const lockUsage : boolean=this.isUsage      && this.lockEditAfterBilledUsage      && hasBilled;

      this.licenceEverBilled=lockBundle || lockPool || lockUsage;

      if (!this.licenceEverBilled)
        return;

      this.billedOverrideUnlocked=false;

      this.setBilledFieldsDisabled(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getBilledLockedFieldNames(): string[] {
    try {
      if (this.isBundle)
        return ["allowanceMbOrGb", "bundlePeriodTypeId", "paymentFrequencyTypeId", "price", "priceEur", "priceUsd", "zoneIDs"];

      if (this.isPoolBundle)
        return this.poolBundlePeriodEnabled
               ? ["allowanceMbOrGb", "bundlePeriodTypeId", "dataWeightTypeId", "paymentFrequencyTypeId", "zoneIDs"]
               : ["allowanceMbOrGb", "dataWeightTypeId", "zoneIDs"];

      if (this.isUsage)
        return ["price", "priceEur", "priceUsd", "pricePerMb", "pricePerMbEur", "pricePerMbUsd", "zoneIDs"];

      return [];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private setBilledFieldsDisabled(disabled: boolean): void {
    try {
      for (const fieldName of this.getBilledLockedFieldNames()) {
        if (disabled)
          this.thisForm.get(fieldName)?.disable({ emitEvent: false });
        else
          this.thisForm.get(fieldName)?.enable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public padlockButtonClick(): void {
    try {
      if (!this.showBilledPadlock)
        return;

      this.billedOverrideUnlocked=!this.billedOverrideUnlocked;

      this.setBilledFieldsDisabled(!this.billedOverrideUnlocked);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private findDataWeightTypeIdByCode(code: string): number | null {
    try {
      const match=this.dataWeightTypeIdData?.find(x => x.description?.endsWith(`(${code})`));

      return match ? <number>match.id : null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public dataWeightShortCode(object: IdAndDescriptionDTO): string {
    try {
      const description: string=object?.description ?? "";
      const match              =description.match(/\(([^)]+)\)\s*$/);

      return match ? match[1] : description;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return object?.description ?? "";
    }
  }

  private getInitialZoneIDs(): number[] {
    try {
      let ids: number[]=[];

      if (this.licenceSystem?.zoneIDs && this.licenceSystem.zoneIDs.length>0)
        ids=this.licenceSystem.zoneIDs;

      else if (this.licenceSystem?.zoneID && this.licenceSystem.zoneID>0)
        ids=[this.licenceSystem.zoneID];

      const zones : IdAndDescriptionDTO[]=this.zoneIdData ?? [];
      const lookup: Map<number, string>  =new Map(zones.map(z => [<number>z.id, (z.description ?? "").toLowerCase()]));

      return [...ids].sort((a, b) => (lookup.get(a) ?? "").localeCompare(lookup.get(b) ?? ""));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public minZoneCountValidator(minCount: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value=<number[]>control.value;

        return (!value || value.length<minCount) ? { minZoneCount: true } : null;
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }
  
  private saveLicenceSystem(licenceSystem: LicenceSystemDTO): Observable<LicenceSystemDTO> {
    return this.licencesSystemService.save(licenceSystem);
  }
  
  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm("Complete", "The licence has been " + (this.newLicence ? "created": "updated"));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalFormClosed() {
    try {
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public onLicenceTypeChange(id: number): void {
    try {
      if (!this.licenceTypeIdData) {
        setTimeout(() => {
          this.onLicenceTypeChange(id);
        }, 500);

      } else {
        if (this.newLicence && this.licenceTypeSelected) {
          this.licenceTypeSelected=undefined;

          this.populateFormFields(this.thisForm, true, false);
        }

        this.licenceTypeSelected=this.licenceTypeIdData.find(x => x.id==id);
        this.isBundle           =this.licenceTypeSelected != undefined && this.licenceTypeSelected.description==TypeLicence.Bundle;
        this.isFeature          =this.licenceTypeSelected != undefined && this.licenceTypeSelected.description==TypeLicence.Feature;
        this.isPlatform         =this.licenceTypeSelected != undefined && this.licenceTypeSelected.description==TypeLicence.Platform;
        this.isPoolBundle       =this.licenceTypeSelected != undefined && this.licenceTypeSelected.description==TypeLicence.PoolBundle;
        this.isUsage            =this.licenceTypeSelected != undefined && this.licenceTypeSelected.description==TypeLicence.Usage;
        this.thisFormSubmitted  =false;
        this.showFeatureQuantity=this.isFeature && (this.licenceSystem?.quantityEnabled ?? false);

        this.refreshFormTitle();
        this.refreshDataWeightTypeIdFilter();
        this.setOrClearValidators();
        this.applyPoolBundlePeriodDefault();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyPoolBundlePeriodDefault(): void {
    try {
      if (!this.isPoolBundle || !this.poolBundlePeriodEnabled)
        return;

      if (!this.bundlePeriodIdData) {
        setTimeout(() => {
          this.applyPoolBundlePeriodDefault();
        }, 500);

      } else {
        const periodCtrl=this.thisForm.get("bundlePeriodTypeId");

        if (periodCtrl?.value==null) {
          const monthly: IdAndDescriptionDTO | undefined=this.bundlePeriodIdData.find(x => x.description=="Monthly");

          periodCtrl?.setValue(monthly ? monthly.id : null);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshFormTitle(): void {
    try {
      const prefix    : string=this.newLicence ? "Create" : "Manage";
      const typeLabel : string=this.licenceTypeSelected?.description ?? "";
      const middlePart: string=typeLabel ? ` ${typeLabel}` : "";

      this.formTitle=`${prefix}${middlePart} Licence`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onBundlePeriodChange(id: number): void {
    try {
      if (!this.bundlePeriodIdData) {
        setTimeout(() => {
          this.onBundlePeriodChange(id);
        }, 500);

      } else {
        const selected   : IdAndDescriptionDTO | undefined=this.bundlePeriodIdData.find(x => x.id==id);
        const wasAnnual  : boolean                        =this.isAnnualBundlePeriod;
        const nowAnnual  : boolean                        =selected != undefined && selected.description=="Annually";
        const paymentCtrl                                 =this.thisForm.get("paymentFrequencyTypeId");

        this.isAnnualBundlePeriod=nowAnnual;

        if (nowAnnual) {
          if (!wasAnnual)
            paymentCtrl?.setValue(null, { emitEvent: false });
        } else {
          const monthly: IdAndDescriptionDTO | undefined=this.paymentFrequencyIdData?.find(x => x.description=="Monthly");

          paymentCtrl?.setValue(monthly ? monthly.id : null, { emitEvent: false });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onQuantityEnableChange(event: Event): void {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
      this.showFeatureQuantity=isChecked;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public enforceDecimals(controlName: string, decimalPlaces: number=2): void {
    try {
      const control=this.thisForm.get(controlName);
      let   value  =control?.value;

      if (value != null && value.toString().includes('.')) {
        const [integer, decimal]=value.toString().split('.');

        if (decimal.length>decimalPlaces) {
          value=`${integer}.${decimal.slice(0, decimalPlaces)}`;
          control?.setValue(value, { emitEvent: false });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public preventDecimal(event: any): void {
    try {
      const disallowedKeys=['e', 'E', '.', ','];
  
      if (disallowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public isPremiumZone(zone: IdAndDescriptionDTO | undefined | null): boolean {
    try {
      return (zone?.description ?? "").trim().toLowerCase()=="premium zone";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public selectAllZones(): void {
    try {
      const zones: IdAndDescriptionDTO[]=this.zoneIdData ?? [];
      const ids  : number[]             =zones.map(zone => <number>zone.id);

      this.thisForm.controls["zoneIDs"].setValue(ids);
      this.thisForm.controls["zoneIDs"].markAsDirty();
      this.thisForm.controls["zoneIDs"].updateValueAndValidity();
      this.sortSelectedZones();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectAllZonesExcludingPremium(): void {
    try {
      const zones: IdAndDescriptionDTO[]=this.zoneIdData ?? [];
      const ids  : number[]             =zones.filter(zone => (zone.description ?? "").trim().toLowerCase() != "premium zone")
                                              .map   (zone => <number>zone.id);

      this.thisForm.controls["zoneIDs"].setValue(ids);
      this.thisForm.controls["zoneIDs"].markAsDirty();
      this.thisForm.controls["zoneIDs"].updateValueAndValidity();
      this.sortSelectedZones();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sortSelectedZones(): void {
    try {
      const control: AbstractControl | null=this.thisForm.get("zoneIDs");
      const ids    : number[]              =<number[]>(control?.value ?? []);

      if (ids.length<2)
        return;

      const zones : IdAndDescriptionDTO[]=this.zoneIdData ?? [];
      const lookup: Map<number, string>  =new Map(zones.map(z => [<number>z.id, (z.description ?? "").toLowerCase()]));
      const sorted: number[]             =[...ids].sort((a, b) => (lookup.get(a) ?? "").localeCompare(lookup.get(b) ?? ""));

      if (sorted.some((id, i) => id != ids[i]))
        control?.setValue(sorted, { emitEvent: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setOrClearValidators(): void {
    try {
      this.thisForm.get("allowanceMbOrGb"       )?.clearValidators();
      this.thisForm.get("bundlePeriodTypeId"    )?.clearValidators();
      this.thisForm.get("dataWeightTypeId"      )?.clearValidators();
      this.thisForm.get("featureGuid"           )?.clearValidators();
      this.thisForm.get("numberOfEntities"      )?.clearValidators();
      this.thisForm.get("paymentFrequencyTypeId")?.clearValidators();
      this.thisForm.get("pricePerMb"            )?.clearValidators();
      this.thisForm.get("pricePerMbEur"         )?.clearValidators();
      this.thisForm.get("pricePerMbUsd"         )?.clearValidators();
      this.thisForm.get("zoneId"                )?.clearValidators();
      this.thisForm.get("zoneIDs"               )?.clearValidators();

      if (this.isPoolBundle) {
        this.thisForm.get("price"   )?.clearValidators();
        this.thisForm.get("priceEur")?.clearValidators();
        this.thisForm.get("priceUsd")?.clearValidators();
      } else {
        this.thisForm.get("price"   )?.setValidators([Validators.required]);
        this.thisForm.get("priceEur")?.setValidators([Validators.required]);
        this.thisForm.get("priceUsd")?.setValidators([Validators.required]);
      }

      if (this.isBundle) {
        this.thisForm.get("allowanceMbOrGb"       )?.setValidators([Validators.required]);
        this.thisForm.get("bundlePeriodTypeId"    )?.setValidators([Validators.required]);
        this.thisForm.get("paymentFrequencyTypeId")?.setValidators([Validators.required]);
        this.thisForm.get("zoneIDs"               )?.setValidators([this.minZoneCountValidator(1)]);

      } else if (this.isFeature) {
        this.thisForm.get("featureGuid"     )?.setValidators([Validators.required]);
        this.thisForm.get("numberOfEntities")?.setValidators([this.quantityValidator()]);

      } else if (this.isPlatform) {
        this.thisForm.get("numberOfEntities")?.setValidators([Validators.required]);

      } else if (this.isPoolBundle) {
        this.thisForm.get("allowanceMbOrGb" )?.setValidators([Validators.required]);
        this.thisForm.get("dataWeightTypeId")?.setValidators([Validators.required]);
        this.thisForm.get("zoneIDs"         )?.setValidators([this.minZoneCountValidator(1)]);

        if (this.poolBundlePeriodEnabled) {
          this.thisForm.get("bundlePeriodTypeId"    )?.setValidators([Validators.required]);
          this.thisForm.get("paymentFrequencyTypeId")?.setValidators([Validators.required]);
        }

      } else if (this.isUsage) {
        this.thisForm.get("pricePerMb"   )?.setValidators([Validators.required]);
        this.thisForm.get("pricePerMbEur")?.setValidators([Validators.required]);
        this.thisForm.get("pricePerMbUsd")?.setValidators([Validators.required]);
        this.thisForm.get("zoneIDs"      )?.setValidators([this.minZoneCountValidator(1)]);

      }

      this.thisForm.get("allowanceMbOrGb"       )?.updateValueAndValidity();
      this.thisForm.get("bundlePeriodTypeId"    )?.updateValueAndValidity();
      this.thisForm.get("dataWeightTypeId"      )?.updateValueAndValidity();
      this.thisForm.get("featureGuid"           )?.updateValueAndValidity();
      this.thisForm.get("numberOfEntities"      )?.updateValueAndValidity();
      this.thisForm.get("paymentFrequencyTypeId")?.updateValueAndValidity();
      this.thisForm.get("price"                 )?.updateValueAndValidity();
      this.thisForm.get("priceEur"              )?.updateValueAndValidity();
      this.thisForm.get("pricePerMb"            )?.updateValueAndValidity();
      this.thisForm.get("pricePerMbEur"         )?.updateValueAndValidity();
      this.thisForm.get("pricePerMbUsd"         )?.updateValueAndValidity();
      this.thisForm.get("priceUsd"              )?.updateValueAndValidity();
      this.thisForm.get("zoneId"                )?.updateValueAndValidity();
      this.thisForm.get("zoneIDs"               )?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region System Lock
  
  private processSystemLock(): void {
    try {
      if (!this.systemLocksEnabled)
        return;

      const systemLock: SystemLockDTO={
        active    : true,
        enteredBy : this.curUser.userId,
        entityID  : this.licenceSystemId ?? -1,
        entityLock: SystemLocks.Licence,
        id        : -1
      };
    
      this.systemLockService.entityIsLocked(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const possibleSystemLock: SystemLockDTO=data;

          if (possibleSystemLock.locked) {

            if (possibleSystemLock.sameUserLock) {
              this.systemLockId=possibleSystemLock.id;
            }
            else {
              this.formIsLocked=true;
              const lockDetail =`Licence is being edited by\n\n${possibleSystemLock.enteredByName}\n\nas of ${this.datePipe.transform(possibleSystemLock.enteredDate, 'dd/MM/yyyy HH:mm:ss')}`;

              if (this.systemLocksShowDetails)
                this.fileLockHoverText=lockDetail;

              if (this.systemLocksShowWarningModal) {
                this.warningModalForm.openForm("WARNING",
                                               (<string>this.fileLockHoverText).replaceAll("\n", "<br>") + "<br><br>Changes are not permitted until the Edit is complete",
                                               "https://cdn.lordicon.com/fikcyfpp.json");
              }

              this.lockDownForm();
            }

          } else {
            this.lockEntity(systemLock);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockEntity(systemLock: SystemLockDTO): void {
    try {
      this.systemLockService.lockEntity(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.systemLockId=data.id;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private unlockEntity(): void {
    try {
      if (!this.systemLocksEnabled || !this.systemLockId || this.systemLockId<0)
        return;

      this.systemLockService.unlockEntity(this.systemLockId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockDownForm(): void {
    try {
      this.thisForm.get("active"                )?.disable();
      this.thisForm.get("addToNewCompany"       )?.disable();
      this.thisForm.get("allowanceMbOrGb"       )?.disable();
      this.thisForm.get("allowMany"             )?.disable();
      this.thisForm.get("bundlePeriodTypeId"    )?.disable();
      this.thisForm.get("dataWeightTypeId"      )?.disable();
      this.thisForm.get("featureGuid"           )?.disable();
      this.thisForm.get("licenceName"           )?.disable();
      this.thisForm.get("licenceTypeId"         )?.disable();
      this.thisForm.get("numberOfEntities"      )?.disable();
      this.thisForm.get("paymentFrequencyTypeId")?.disable();
      this.thisForm.get("platformAddOn"         )?.disable();
      this.thisForm.get("price"                 )?.disable();
      this.thisForm.get("priceEur"              )?.disable();
      this.thisForm.get("pricePerMb"            )?.disable();
      this.thisForm.get("pricePerMbEur"         )?.disable();
      this.thisForm.get("pricePerMbUsd"         )?.disable();
      this.thisForm.get("priceUsd"              )?.disable();
      this.thisForm.get("quantityEnabled"       )?.disable();
      this.thisForm.get("zoneId"                )?.disable();
      this.thisForm.get("zoneIDs"               )?.disable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
